export enum ChartDataType {
  primary = 'primary',
  secondary = 'secondary',
  breakdown = 'breakdown',
  average = 'average',
  band = 'band',
}
